<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-md-12">
        <div class="row" v-if="!isLoading">
          <div class="col-md-12 mx-auto">
            <table class="table table-striped table-bordered table-hover">
              <tbody>
                <tr>
                  <td>
                    <b>{{ $t("pages.documentType.name") }}</b>
                  </td>
                  <td>{{ documentType.name }}</td>
                </tr>
                <tr>
                  <td>
                    <b>{{ $t("pages.documentType.description") }}</b>
                  </td>
                  <td>{{ documentType.description }}</td>
                </tr>
                <tr>
                  <td>
                    <b>{{ $t("pages.documentType.metadata") }}</b>
                  </td>
                  <td>
                    <ul>
                      <li v-for="data in metadata" :key="data.id">
                        {{ data.label }}
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-4 mb-3">
              <div class="row">
                <div class="col-md-12">
                  <router-link :to="{
                    path: `/document-types/edit/${documentType.id}`,
                  }" class="btn btn-primary mr-2">{{ $t("pages.documentType.edit") }}</router-link>
                  <router-link :to="{ name: 'DocumentTypes' }" class="btn btn-light">{{ $t("pages.documentType.back") }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row p-4" v-else>
          <div v-if="isLoading" class="col-md-12">
            <b-skeleton-table :rows="3" :columns="2"></b-skeleton-table>
          </div>
          <div class="col-md-2">
            <b-skeleton height="36px"></b-skeleton>
          </div>
          <div class="col-md-2">
            <b-skeleton height="36px"></b-skeleton>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions, mapState } from "vuex";

export default {
  page: {
    title: "Documents Types",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      title: "pages.documentType.details",
      items: [
        {
          text: "menuitems.dashboards.text",
        },
        {
          text: "document-types",
        },
        {
          text: "pages.documentType.display",
          active: true,
        },
      ],

      isLoading: false,
      isDeleting: false,
    };
  },

  methods: {
    ...mapActions(["getDocumentTypeMetadas", "deleteDocumentType"]),
    onDelete(id) {
      if (this.$can("delete", "document-types")) {
        this.$toasted.clear();
        this.$confirm(`Voulez-vous supprimer ce type de document ?`).then(
          () => {
            this.deleteDocumentType(id).then((response) => {
              if (response.status == 200) {
                this.isDeleting = true;
                this.$toasted.success("Le type de document a été supprimé");
                this.$router.push({ name: "DocumentTypes" });
              } else {
                this.isDeleting = false;
              }
            });
          }
        );
      } else {
        this.isLoading = false;
        this.$toasted.error(
          "Une erreur est survenue, Veuillez réessayer SVP...",
          {
            duration: 3000,
            position: "top-center",
          }
        );
      }
    },

    load_image(picture) {
      return process.env.VUE_APP_IMAGE_URL + picture;
    },
  },
  computed: {
    ...mapState({
      metadata: (state) => state.documentType.documentTypeMetadata,
      documentType: (state) => state.documentType.documentType,
    }),
  },
  created() {
    if (this.$can("read", "document-types")) {
      this.$store.commit("CLEAR_USER");
      this.isLoading = true;
      this.getDocumentTypeMetadas(this.$route.params.id)
        .then((response) => {
          if (response.status == 200) {
            this.isLoading = false;
          } else {
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    }
  },
};
</script>